import { isEqual } from 'lodash'
import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect'
import { IUser } from 'models/User'
import { AppState } from 'store/types'
/**
 *
 * @param state - the application state
 * @returns auth - the current user reducer
 */
export const selectUserReducer = (state: AppState) => state.auth

/**
 * Gets the auth data object from the auth reducer
 */
export const selectUserReducerData = (state: AppState) => state.auth.data

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual)
/**
 * Gets the user object from the user reducer
 */
export const selectUserDeepEqual = createDeepEqualSelector(
  selectUserReducerData,
  userState => userState.user as IUser,
)
/**
 * Gets the user object from the user reducer
 */
export const selectUser = createSelector(
  selectUserReducerData,
  userState => userState.user as IUser,
)

/**
 * Gets the loading flag from the user reducer
 */
export const selectUserIsLoading = createSelector(
  selectUserReducer,
  userState => userState.isLoading,
)

/**
 * Gets the locationAllowed flag from the user reducer
 */
export const selectUserLocationAllowed = createSelector(
  selectUserReducerData,
  userState => userState.locationAllowed,
)

/**
 * Gets the gettingLocation flag from the user reducer
 */
export const selectUserIsFetchingLocation = createSelector(
  selectUserReducerData,
  userState => userState.gettingLocation,
)

/**
 * Gets the role from the user object from the user reducer
 */
export const selectUserRole = createSelector(
  selectUserReducerData,
  user => user.role,
)

/**
 * Gets the email from the user object from the user reducer
 */
export const selectUserEmail = createSelector(selectUser, user => user.email)

/**
 * Gets the imageLoader from the user reducer
 */
export const selectImageLoader = createSelector(
  selectUserReducerData,
  user => user.imageLoader,
)

/**
 * Gets the role from the user object from the user reducer
 */
export const selectLoggedInUserRole = createSelector(
  selectUserReducerData,
  user => user.user.role,
)
